import { render, staticRenderFns } from "./how-it-works-mini-card.vue?vue&type=template&id=cc2fb670&scoped=true&lang=pug"
import script from "./how-it-works-mini-card.js?vue&type=script&lang=js&external"
export * from "./how-it-works-mini-card.js?vue&type=script&lang=js&external"
import style0 from "./how-it-works-mini-card.vue?vue&type=style&index=0&id=cc2fb670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2fb670",
  null
  
)

export default component.exports